import React from "react";
import { Box } from "@mui/material";
import Navbar from "components/Navbar/index";
import FooterSection from "components/FooterSection/index";
import AboutHeroSection from "components/AboutHeroSection/index";
import AboutUsSection from "components/AboutUsSection/index";
import StatisticsSection from "components/StatisticsSection/index";
import OurCommitmentSection from "components/OurCommitmentSection/index";
import MoreThanDietSection from "components/MoreThanDietSection/index";
import WhyCollaborateSection from "components/WhyCollaborateSection/index";
import PricingSection from "components/PricingSection";

const AboutPage = () => {
  return (
    <Box
      sx={{
        minHeight: "auto",
        backgroundColor: "#1A1A1A",
        color: "#FFFFFF",
        position: "relative",
        overflow: "hidden",
        fontFamily: "Outfit",
      }}
    >
      {/* Navigation */}
      <Navbar />

      {/* Hero Section */}
      <AboutHeroSection />

      {/* About Us Section */}
      <AboutUsSection />

      {/* Statistics Section */}
      <StatisticsSection />

      {/* Our Commitment Section */}
      <OurCommitmentSection />

      {/* More Than Diet Section */}
      <MoreThanDietSection />

      {/* Why Collaborate Section */}
      <WhyCollaborateSection />

      <PricingSection />

      {/* Footer Section */}
      <FooterSection />
    </Box>
  );
};

export default AboutPage;
